import axios from 'axios';
import { FileActions } from '@vooban/file';
import { englishLocalesCode } from '../../i18n';

const { preview } = FileActions;

const url = `/api/v1/user-guide/download`;

export const fetchUserGuide = (language) => axios.get(url, { responseType: 'blob', ...(language && { headers: { 'Accept-Language': language } }) });

const getUserGuide = async (language) => {
  const response = await fetchUserGuide(language);
  preview(response.data, language === englishLocalesCode ? 'Customer_User Guide' : 'Portail client_Guide d’utilisateur');
};

const userGuideAgents = { getUserGuide };

export default userGuideAgents;
